import type { ReactNode } from 'react';

import Box from '@mui/material/Box';

interface Props {
  readonly children: ReactNode;
}

export const WordBreak = ({ children }: Readonly<Props>) => (
  <Box component="span" sx={{ wordBreak: 'break-all', whiteSpace: 'pre-wrap' }}>
    {children}
  </Box>
);
